import { createElementFromHTML } from '../thirdPartyTracking/helpers';

const trackingUrlNames = {
	engaged: 'trackEngagedUrl',
	viewed: 'trackViewedUrl'
}

export function iponWebTracking(trackingType, state){
    const trackingURL = state.widget.iponWeb[trackingUrlNames[trackingType]];

    if (trackingURL){
		createElementFromHTML(`<img src="${decodeURIComponent(trackingURL)}" width=1 height=1 border=0 />`);
    };
}
